import EChartsReact from 'echarts-for-react'
import { observer } from 'mobx-react-lite'
import React, { useMemo } from 'react'
import { ArrowDown, ArrowUp, Cursor } from 'react-bootstrap-icons'
import { formatNumber } from '../../../../../utils/Helper'

export default observer(function LikesComments({ currentAuthentication }) {

  const histories = useMemo(() => currentAuthentication.authentication_histories, [currentAuthentication.authentication_histories, currentAuthentication.authentication_histories.length])

  const sum = useMemo(() => {
    if(!histories.length) return 0
    return histories[histories.length - 1].average_likes + histories[histories.length - 1].average_comments
  }, [histories, histories.length])

  const likesOption = useMemo(() => ({
    title: {
      text: 'Likes per Month',
      padding: [20, 0, 0, 60]
    },
    xAxis: {
      data: histories.map(history => history.history_changed_at)
    },
    yAxis: {},
    series: [
      {
        data: histories.map(history => history.average_likes),
        type: 'line',
        smooth: true,
        color: '#2563EB',
        areaStyle: {
          color: '#2563EB',
          opacity: 0.25
        }
      }
    ],
    tooltip: {
      trigger: 'item',
      formatter: '{c}'
    },
  }), [histories, histories.length])

  const commentsOption = useMemo(() => ({
    title: {
      text: 'Comments per Month',
      padding: [20, 0, 0, 60]
    },
    xAxis: {
      data: histories.map(history => history.history_changed_at)
    },
    yAxis: {},
    series: [
      {
        data: histories.map(history => history.average_comments),
        type: 'line',
        smooth: true,
        color: '#EAB308',
        areaStyle: {
          color: '#EAB308',
          opacity: 0.25
        }
      }
    ],
    tooltip: {
      trigger: 'item',
      formatter: '{c}'
    },
  }), [histories, histories.length])

  const comments = useMemo(() => {
    if(!histories.length) return 0
    return histories[histories.length - 1].average_comments
  }, [histories, histories.length])

  const commentsGrowthPercentage = useMemo(() => {
    if(histories.length < 2) return 0
    const currentFollowerCount = histories[histories.length - 1].average_comments
    const previousFollowerCount = histories[histories.length - 2].average_comments
    if(currentFollowerCount === 0 && previousFollowerCount === 0) return 0
    if(previousFollowerCount === 0) return 'Infinity'
    return ((currentFollowerCount - previousFollowerCount) / previousFollowerCount * 100).toFixed(2)
  }, [histories, histories.length])

  const likes = useMemo(() => {
    if(!histories.length) return 0
    return histories[histories.length - 1].average_likes
  }, [histories, histories.length])

  const likesGrowthPercentage = useMemo(() => {
    if(histories.length < 2) return 0
    const currentFollowerCount = histories[histories.length - 1].average_likes
    const previousFollowerCount = histories[histories.length - 2].average_likes
    if(currentFollowerCount === 0 && previousFollowerCount === 0) return 0
    if(previousFollowerCount === 0) return 'Infinity'
    return ((currentFollowerCount - previousFollowerCount) / previousFollowerCount * 100).toFixed(2)
  }, [histories, histories.length])

  return (
    <div className="w-full bg-white dark:bg-rb-dark-mode rounded-lg col-span-2">
      <div className="flex justify-between p-8 border-b-1 border-gray-300 dark:border-rb-dark-mode-lighter">
        <div className="flex items-center">
          <div className="mr-2 dark:text-white"><Cursor /></div>
          <p className="font-bold text-xl dark:text-white">Total Interactions</p>
        </div>
        <p className="font-bold dark:text-white">{formatNumber(+sum)}</p>
      </div>
      <EChartsReact option={likesOption} style={{ width: '100%', height: '300px' }} />
      <EChartsReact option={commentsOption} style={{ width: '100%', height: '300px' }} />

      <div className="flex justify-between p-8 border-t-1 border-gray-300 dark:border-rb-dark-mode-lighter">
        <div className="flex items-center">
          <p className="font-bold text-gray-300 dark:text-gray-400 mr-2">Comment</p>
          <p className="font-bold mr-4 dark:text-white">{formatNumber(+comments)}</p>
          <div>
            {commentsGrowthPercentage >= 0 &&
              <div className="text-green-500"><ArrowUp /></div>
              || <div className="text-red-500"><ArrowDown /></div>
            }
          </div>
          <p className={`font-bold ${commentsGrowthPercentage >= 0 ? 'text-green-500' : 'text-red-500'}`}>{commentsGrowthPercentage}%</p>
        </div>
        <div className="flex items-center">
          <p className="font-bold text-gray-300 dark:text-gray-400 mr-2">Likes</p>
          <p className="font-bold mr-4 dark:text-white">{formatNumber(+likes)}</p>
          <div>
            {likesGrowthPercentage >= 0 &&
              <div className="text-green-500"><ArrowUp /></div>
              || <div className="text-red-500"><ArrowDown /></div>
            }
          </div>
          <p className={`font-bold ${likesGrowthPercentage >= 0 ? 'text-green-500' : 'text-red-500'}`}>{likesGrowthPercentage}%</p>
        </div>
      </div>
    </div>
  )
})